(function() {
    'use strict';
    angular
        .module('wamasysApp')
        .factory('CoutAchatEau', CoutAchatEau);

    CoutAchatEau.$inject = ['$resource', 'DateUtils'];

    function CoutAchatEau ($resource, DateUtils) {
        var resourceUrl =  'api/cout-achat-eaus/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    data = angular.fromJson(data);
                    data.dateAjout = DateUtils.convertDateTimeFromServer(data.dateAjout);
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
